import { Injectable } from '@angular/core';

/**
 * Centralized auth storage — tokens in sessionStorage (tab-scoped, cleared on browser close).
 */
@Injectable({ providedIn: 'root' })
export class AuthStorageService {
  private readonly keys = ['token', 'jwtToken', 'companyId', 'myVal', 'isFirstLogin'];

  getJwtToken(): string | null {
    const v = sessionStorage.getItem('jwtToken');
    return this.isValid(v) ? v : null;
  }

  getUserId(): string | null {
    const v = sessionStorage.getItem('token');
    return this.isValid(v) ? v : null;
  }

  isLoggedIn(): boolean {
    return !!this.getJwtToken() && !!this.getUserId();
  }

  setSession(user: {
    _id: string;
    token: string;
    companyId?: string;
    email?: string;
    isFirstLogin?: boolean;
  }): void {
    sessionStorage.setItem('token', user._id);
    sessionStorage.setItem('jwtToken', user.token);
    if (user.companyId) {
      sessionStorage.setItem('companyId', user.companyId);
    }
    if (user.email) {
      sessionStorage.setItem('myVal', JSON.stringify(user.email));
    }
    if (user.isFirstLogin) {
      sessionStorage.setItem('isFirstLogin', 'true');
    }
  }

  clear(): void {
    this.keys.forEach((k) => sessionStorage.removeItem(k));
  }

  private isValid(value: string | null): boolean {
    return value != null && value !== '' && value !== 'undefined' && value !== 'null';
  }
}
